import { render, staticRenderFns } from "./CustomerModal.vue?vue&type=template&id=688d1d0e&scoped=true"
import script from "./CustomerModal.vue?vue&type=script&lang=js"
export * from "./CustomerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688d1d0e",
  null
  
)

export default component.exports